import { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import "./gamificationexternalsharing.css";
import { LanguageContext } from "../../context/language/LanguageContext";
import Alert from 'react-bootstrap/Alert';
import { offerwallapi } from "../../config/axiosconfig";
import queryString from 'query-string';
import { isMobile } from 'react-device-detect';
import { Spinner, Button } from 'react-bootstrap';
import DOMPurify from "dompurify";

export default function GamificationExternalSharing() {

    const params = useParams();
    const tenantId = params.teid;
    const tnxId = params.txid;
    const type = params.type;

    const { language, languagedispatch } = useContext(LanguageContext);
    const [reward, setReward] = useState(0);
    const [rewardImage, setRewardImage] = useState('');
    const [caption, setCaption] = useState('');
    const [url, setUrl] = useState('');
    const [langId, setLangId] = useState(0);
    const [copied, setCopied] = useState(false);
    const [loader, setLoader] = useState(false);

    useEffect(()=> {
        setCaption(`${language?.static_labels.sharing_content_1} ${reward} ${language?.static_labels.yen} ${language?.static_labels.sharing_content_2} ${language?.static_labels.sharing_content_3} ${language?.static_labels.sharing_content_4} ${language?.static_labels.sharing_link} ${language?.static_labels.sharing_tags} ${language?.static_labels.sharing_hash_tags}`);
        setUrl(language?.static_labels.sharing_link);
    }, [reward, language])

    const getLanguage = async (languageid) => {
        try {
            languagedispatch({ type: "LANGUAGE_START" });
            const res = await offerwallapi.get("/api/public/multilingual/" + languageid);

            languagedispatch({ type: "LANGUAGE_SUCCESS", payload: JSON.parse(res.data.osakalanguagecontent) });
        } catch (err) {
            languagedispatch({ type: "LANGUAGE_FAIL", payload: err });
        }
    }

    useEffect(() => {
        getLanguage(529);
    }, [langId])

    const handleWebShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: caption,
                    text: caption,
                    url: url,
                    files: [new File([await fetch(`/api/common/fetch-image?url=${DOMPurify.sanitize(rewardImage)}`).then(res => res.blob())], 'image.png', { type: 'image/png' })],
                });
                console.log('Share was successful.');
            } catch (error) {
                console.error('Sharing failed:', error);
            }
        } else {
            alert('Web Share API not supported in your browser.');
        }
    }

    const executeAction = async () => {
        addSocialShareDetails();
        if(type==='instagram'){
            const baseUrl = 'https://www.instagram.com/';
            const mediaUrl = encodeURIComponent(rewardImage);
            const instagramShareUrl = `${baseUrl}/?${queryString.stringify({ url: mediaUrl, caption })}`;
            window.open(instagramShareUrl, '_blank');
        }
        if (type === 'twitter') {
            if(isMobile){
                await handleWebShare()
            }else{
                const twitterShareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(caption)}`;
                window.open(twitterShareUrl, '_blank');
            }
        }
        
    };

    useEffect(()=> {
        getWiningRewardDetails();
    }, [])

    const handleDownload = async () => {
        const sanitizedUrl = DOMPurify.sanitize(rewardImage);
    
        try {
            const urlObject = new URL(sanitizedUrl);
            if (urlObject.protocol !== 'http:' && urlObject.protocol !== 'https:') {
                throw new Error('Invalid URL protocol');
            }
        } catch (error) {
            console.error('Invalid URL:', error);
            return;
        }
    
        const escapedUrl = encodeURIComponent(sanitizedUrl);
    
        const response = await fetch(`/api/common/fetch-image?url=${escapedUrl}`);
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
    
        const a = document.createElement('a');
        a.href = DOMPurify.sanitize(url);
        a.download = 'VisaWariChanceCashback.png';
    
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        URL.revokeObjectURL(url);
    };

    const getWiningRewardDetails = async () => {
        setLoader(true);
        let info = {
            tnxId: tnxId,
            tenantid: tenantId,
        }
        const res = await offerwallapi.post("/api/gamification/get-wining-reward-details", info);
        if (res.status === 200) { 
            setReward(parseInt(res.data.rewardDetails.rewardAmount));
            setRewardImage(res.data.rewardDetails.rewardImage[res.data.langId]);
            setLangId(res.data.langId);
        }
        setLoader(false);
    }

    const addSocialShareDetails = async () => {
        let info = {
            tnxId: tnxId,
            tenantid: tenantId,
            platform: type === 'twitter' ? "X" : type
        }
        const res = await offerwallapi.post("/api/gamification/add-social-share-details", info);
        if (res.status === 200) {}
    }

    const marginAlert = {
        margin: '0 200px',
        paddingBottom: copied ? '30px' : '15px'
    }

    return <>
        {loader ? <div style={{ minHeight: '100vlh' }}>
            <div className="ow-full-overlay">
                <div className="position-absolute ow-content-center text-center">
                    <Spinner animation="border" backdrop="static" variant="light" />
                </div>
            </div>
        </div> : <div style={{ minHeight: '100vlh', zIndex: 99, margin: '20px' }}>
        <div className="align-center up-down-margin-40">
                    <p style={{ fontSize: '18px', color: '#000000', fontWeight: 'bold' }}>{language?.static_labels.share_post_title}</p>
        </div>
        <Alert style={!isMobile ? marginAlert : { paddingBottom: copied ? '30px' : '15px' }} variant="secondary">
            <p style={{ color: 'black' }}>
                {language?.static_labels.sharing_content_1} {reward} {language?.static_labels.yen} {language?.static_labels.sharing_content_2} <br /> 
                        {language?.static_labels.sharing_content_3} <br />
                        {language?.static_labels.sharing_content_4} <a style={{ color: 'black' }} href={language?.static_labels.sharing_link} target="_blank">{language?.static_labels.sharing_link}</a> {language?.static_labels.sharing_tags} <b>{language?.static_labels.sharing_hash_tags}</b>
            </p>
            <div className="d-flex justify-content-end">
                <Button onClick={() => {
                    navigator.clipboard.writeText(
                        `${language?.static_labels.sharing_content_1} ${reward} ${language?.static_labels.yen} ${language?.static_labels.sharing_content_2} ${language?.static_labels.sharing_content_3} ${language?.static_labels.sharing_content_4} ${language?.static_labels.sharing_link} ${language?.static_labels.sharing_tags} ${language?.static_labels.sharing_hash_tags}`
                    );
                    setCopied(true);
                    setTimeout(function () {
                        setCopied(false);
                    }, 2500);
                }} variant="secondary">
                    {language?.static_labels.copy}
                </Button>
            </div>
            {copied ? <div style={{ float: 'right' }}>
                <p className="font-11" style={{ color: 'green' }}>{language?.static_labels.copied_to_clipboard}</p>
            </div> : null}
        </Alert>
        <div className="align-center">
            <div className="up-down-margin-40">
                <img src={DOMPurify.sanitize(rewardImage)} alt="rewardImage" />
            </div>
            <div style={{ marginTop: '-100px', marginBottom: '75px' }}>
                <Button style={{
                    backgroundColor: '#000000', color: '#FFFFFF', borderRadius: '25px', border: 'none'
                }} onClick={handleDownload} variant="custom"><i class="bi bi-arrow-down"></i>{language?.static_labels.download_image}</Button>
            </div>
            <div className="up-down-margin-40">
                <p style={{ color: 'black' }}>
                    {language?.static_labels.sharing_instruction_1}<br />
                    {language?.static_labels.sharing_instruction_2}
                </p>
            </div>
            <div className="up-down-margin-40">
                <Button style={{ borderRadius: '25px' }} variant="primary" onClick={executeAction}>{language?.static_labels.share_post}</Button>
            </div>
        </div>
    </div> }
    </>
}